import { inject, Injectable, Pipe, PipeTransform } from '@angular/core'
import { BusinessNameService } from '@core/services/business.service'

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'businessNameLayer',
})
export class LayerNamePipe implements PipeTransform {
  private readonly _businessNameService = inject(BusinessNameService)

  transform(value: string): string {
    if (value === null) {
      return 'Nothing to transform'
    }
    const valueTransformed = this._businessNameService.getReadableLayerName(value)
    return valueTransformed
  }
}
